<template>
   <vue-final-modal
      v-model="v310Modal" 
      @click-outside="beforeClose()"
      @before-open="beforeOpen()"
      @opened="opened()"
      classes="modal-container"
      content-class="v310-modal-content"
      drag-selector=".drug-area"
      :drag="true"
      :click-to-close="false"
      >
      <!--
      @click-outside="$emit('cancel')"
            @click="$emit('cancel')"
       -->
      <div class="drug-area">
      <button 
            id="first"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="tabIndexNumber(2)" 
            @click="beforeClose()"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Filtrar</span>
      </div>
      <!-- 
      <div class="up-voucher rounded-2 border p-2">
      -->
      <div class="up-voucher border-top p-1 mt-1">
         <div class="container px-1">
            <Form
               @submit="nextStep"
               :validation-schema="currentSchema"
               keep-values
               :initial-values="dataVoucher"
               v-slot="{ meta }"
               >
               
               <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last').focus()"></div>
               
               <nav>
                  <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                     <!-- ID -->
                     <button class="nav-link active py-1 px-1" data-bs-toggle="tab"
                        id="nav-0-tab" type="submit" role="tab" 
                        :tabindex="tabIndexNumber(3)"
                        @click="tabNumber( 0, meta.valid )"
                        :disabled="!meta.valid || readyToFilter"
                        >
                        ID
                     </button>
                     <!-- CUIL -->
                     <button class="nav-link py-1 px-1" data-bs-toggle="tab"
                        id="nav-1-tab" type="submit" role="tab" 
                        :tabindex="tabIndexNumber(4)"
                        @click="tabNumber( 1, meta.valid )"
                        :disabled="!meta.valid || readyToFilter"
                        >
                        CUIL
                     </button>
                     <!-- Dates -->
                     <button class="nav-link py-1 px-1" data-bs-toggle="tab"
                        id="nav-2-tab" type="submit" role="tab" 
                        :tabindex="tabIndexNumber(5)"
                        @click="tabNumber( 2, meta.valid )"
                        :disabled="!meta.valid || readyToFilter"
                        >
                        Fechas
                     </button>
                     <!-- State -->
                     <button class="nav-link py-1 px-1" data-bs-toggle="tab"
                        id="nav-3-tab" type="submit" role="tab" 
                        :tabindex="tabIndexNumber(6)"
                        @click="tabNumber( 3, meta.valid )"
                        :disabled="!meta.valid || readyToFilter"
                        >
                        Provincia
                     </button>
                     <!-- User -->
                     <button class="nav-link py-1 px-1" data-bs-toggle="tab"
                        id="nav-4-tab" type="submit" role="tab" 
                        :tabindex="tabIndexNumber(7)"
                        @click="tabNumber( 4, meta.valid )"
                        :disabled="!meta.valid || readyToFilter"
                        >
                        Usuario
                     </button>
                  </div>
               </nav>

               <div v-if="readyToFilter">

                  <div v-if="filterId">
                     ID: <br>
                     <div class="border rounded ps-1 pb-1">
                        <b>{{ dataVoucher.id }}</b>
                     </div>
                  </div>
                  <div v-if="filterCuil">
                     CUIL: <br>
                     <div class="border rounded ps-1 pb-1">
                        <b>{{ dataVoucher.cuil }}</b>
                     </div>
                  </div>
                  <div v-if="filterDates">
                     Fechas de <b>{{ radioSelectName }}</b>: <br>
                     <div class="border rounded ps-1 pb-1">
                        Desde: <b>{{ dataVoucher.dateFrom }}</b> <br>
                        Hasta: <b>{{ dataVoucher.dateTo }}</b>
                     </div>
                  </div>
                  <div v-if="filterState">
                     Provincia: <br>
                     <div class="border rounded ps-1 pb-1">
                        <b>{{ states.find(item => item.id == dataVoucher.stateId).name }}</b>
                     </div>
                  </div>
                  <div v-if="filterUser">
                     Usuario: <br>
                     <div class="border rounded ps-1 pb-1">
                        <b>{{ usersApp.find(item => item.id == dataVoucher.userId).name }}</b>
                     </div>
                  </div>
               </div>
               <div v-else>
                  <!-- ID -->
                  <div v-if=" currentStep == 0 " class="p-0 m-0">
                     <common-field :fieldData="v310Cnf.id" :tabindex="tabIndexNumber(3)" :id="'ffield'"/>
                  </div>
                  <!-- CUIL -->
                  <div v-if=" currentStep == 1 " class="p-0 m-0">
                     <special-button-field 
                           :fieldData="v310Cnf.cuil" 
                           :tabindex="tabIndexNumber(4)" 
                           :id="'ffield'"
                           :changeValue="changeValue"
                           :newValue="newCuilValue"
                           @onButtonClick="searchAffil = true"
                           @onBlur="onBlurCuit = true" 
                           @onFocus="onBlurCuit = false" 
                           >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                     <!-- 
                           :resetButton="'resetCuil'"
                     -->
                  </div>
                  <div v-if=" currentStep == 1 && validCuil " class="p-0 m-0">
                     <affiliate-data v-if="validCuil"
                        :dataAffiliate="dataAffil" 
                        class="col-12 rounded border mt-1"
                        />
                  </div>
                  <!-- Dates -->
                  <div v-if=" currentStep == 2 " class="p-0 m-0 row">
                     <!-- <common-field :fieldData="v310Cnf.id3" :tabindex="tabIndexNumber(5)" :id="'ffield'"/> -->
                     <div class="col-6 row mx-0 px-1">
                        <div class="col-12">
                           <Field name="dates" type="radio" 
                              value="request" :tabindex="tabIndexNumber(5)"
                              @click="radioSelect('Solicitud')"
                              /> Solicitud
                        </div>
                        <div class="col-12">
                           <Field name="dates" type="radio" 
                              value="create" :tabindex="tabIndexNumber(5)"
                              @click="radioSelect('Autorización')"
                              /> Autorización
                        </div>
                        <div class="col-12">
                           <Field name="dates" type="radio" 
                              value="prescription" :tabindex="tabIndexNumber(5)"
                              @click="radioSelect('Prescripción')"
                              /> Prescripción
                        </div>
                        <div class="col-12">
                           <Field name="dates" type="radio" 
                              value="validity" :tabindex="tabIndexNumber(5)"
                              @click="radioSelect('Vigencia')"
                              /> Vigencia
                        </div>
                     </div>
                     <div class="col-6 row mx-0 px-1">
                        <common-field :fieldData="v310Cnf.dateFrom" :tabindex="tabIndexNumber(5)" :id="'ffield'"/>
                        <common-field :fieldData="v310Cnf.dateTo" :tabindex="tabIndexNumber(5)" />
                     </div>
                  </div>
                  <!-- states -->
                  <div v-if=" currentStep == 3 " class="pt-2 ps-1 m-0">
                     <div v-for="(state, index) in states" 
                           :key="index"
                           class="list-filter rounded"
                           @click="getState( state.id )"
                           >
                        <div class="row mx-0">
                           <div class="col-10 px-1">
                              <b>{{state.name}}</b>
                           </div>
                           <div class="col-2">
                              <font-awesome-icon v-if=" state.id == dataVoucher.stateId " icon="check" />
                           </div>
                        </div>
                     </div>
                  </div>
                  <!-- users -->
                  <div v-if=" currentStep == 4 " class="pt-2 m-0 row gap-1">
                     <div v-for="(user, index) in usersApp" 
                           :key="index"
                           class="list-filter rounded px-1"
                           @click="getFilterUser( user.id )"
                           >
                        <div class="row mx-0">
                           <div class="col-1 px-0">
                              <userCircle :circleUser="user"/>
                           </div>
                           <div class="col-10 text-start"
                                 >
                              <b>{{user.name}}</b>
                           </div>
                           <div class="col-1 px-0 text-center">
                              <font-awesome-icon v-if=" user.id == dataVoucher.userId " icon="check" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!--  -->
               <!--
                     <div v-if=" currentStep == 11 " class="p-0 m-0">
                        <common-field :fieldData="v310Cnf.id2" :tabindex="tabIndexNumber(4)"/>
                     </div>
               {{currentTab}}
               <br>
               {{currentStep}}
               <br>
               {{meta}}
               -->
               <!--
               -->
               
               <div class="row p-0 justify-content-between border-top mt-2 mx-0">
                  <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
                  <div class="d-flex justify-content-end pt-2 px-0 col-10">
                     <!--
                     -->
                     <!--
                     <button v-if="currentStep == lastStep && !showV310"
                           type="submit" 
                           :tabindex="2" 
                           :id="'first'" 
                           class="btn btn-outline-light btn-sm me-2"
                           @click="updateVoucher()"
                           >
                        Guardar
                     </button>
                     -->
                     <button v-if="readyToFilter"
                           type="button" 
                           :tabindex="tabIndexNumber(8)" 
                           class="btn btn-outline-light btn-sm me-1"
                           @click="doFilter(true)"
                           >
                        Filtrar
                     </button>
                     <button v-if="filterOn"
                           type="button" 
                           :tabindex="tabIndexNumber(9)" 
                           class="btn btn-outline-light btn-sm me-1" 
                           @click="doFilter(false)"
                           >
                        Dejar de Filtrar
                     </button>
                     <button type="submit" 
                           class="btn btn-outline-light btn-sm me-2" 
                           :tabindex="tabIndexNumber(10)"
                           @click="tabNumber( -1, meta.valid )"
                           id="last"
                           >
                           <div v-if="readyToFilter">Modificar</div>
                           <div v-else>Aceptar</div>
                     </button>
                     <div :tabindex="tabIndexNumber(11)" onfocus="document.getElementById('first').focus()"></div>
                  </div>
               </div>
               <!--
                     <button v-if="currentStep == lastStep"
                           type="submit" 
                           :tabindex="currentLastTabIndex + 2" 
                           class="btn btn-outline-light btn-sm me-2"
                           >
                        Guardar
                     </button>
               -->
               <!-- 
               <pre>{{ radioSelectName }}</pre>
               <pre>{{ meta.valid }}</pre>
               <pre>{{ usersApp }}</pre>
               <pre>{{ values }}</pre>
               <pre>{{ dataVoucher }}</pre>
               <pre>{{ prescribedDrugs }}</pre>
               <pre>{{ cmpRequestDate }}</pre>
               <pre>{{ upWizardDrugs }}</pre>
               <pre>{{ chronicDiseases }}</pre>
               <pre>{{ code310Drugs }}</pre>
               <pre>{{ onBlurCuit }}</pre>
                  -->
            </Form>
         </div>
      </div>
   </vue-final-modal>
   <up-wizard-drugs v-if="upWizardDrugs" 
      :chronics="chronicDiseases"
      :v310drugs="code310Drugs"
      @cancel="upWizardDrugs = false"
      @upDrugs="(val) => addDrugs(val)"
      @freeDrug="(val) => up310Drugs(val)"
      />
   <search-affiliate v-if="searchAffil"
      @cancel="searchAffil = false"
      @cuil="(val) => upCuil(val)"
      />
</template>

<script>

//import { ref, onMounted, watch, watchEffect, nextTick, getCurrentInstance } from 'vue';
//import { Form, Field, ErrorMessage } from 'vee-validate';
//import { string, date, object } from "yup";

import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick, watch } from 'vue';
import { useStore } from 'vuex'
import { Form, Field, defineRule } from 'vee-validate';
import * as yup from 'yup';
//import moment from 'moment';
import html2pdf from 'html2pdf.js';

import WspService from '../../workSpace/workSpace.service';
import V310Service from '../voucher310.service';
import AnalyService from '../../analytics/analytics.service';
import AdminService from '../../systemAdmin/admin.service';

import AffiliateData from '../../analytics/components/affiliate/AffiliateDataShow.vue';
import CommonField from './CommonField.vue';
import SearchAffiliate from '../../analytics/components/affiliate/SearchAffiliate.vue';
//import SelectField from './SelectField.vue';
import SpecialButtonField from './SpecialButtonField.vue';
//import TextareaField from './TextareaField.vue';
import UpWizardDrugs from './UpWizardDrugs.vue';
import UserCircle from '../../../components/UserCircle.vue';
//import Voucher310Pdf from './Voucher310Pdf.vue';

export default {

   components: {
      AffiliateData,
      CommonField,
      Field,
      Form,
      SearchAffiliate,
      //SelectField,
      SpecialButtonField,
      //TextareaField,
      UserCircle,
      UpWizardDrugs,
      //Voucher310Pdf,
      VueFinalModal
   },
   props: {
      filterOnOff: Boolean
   },

   emits: [ 'cancel', 'doFilter' ],

   setup(props, { emit }) {

      defineRule('dfrValCuil', value => {

         console.log(value)
         if ( validCuil.value && onBlurCuit.value) {
            return true
         }

         validCuil.value = false
         console.log(value)

         if ( value === undefined ) { return true }
         if ( value == '' ) { return true }
         if ( isNaN( value ) ) { return 'Debe ser un número!' }
         if ( value < 20000000000 ) { return 'Número de CUIL inválido!' }
         if ( value > 40000000000 ) { return 'Número de CUIL inválido!' }
         if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }
         
         return dfrValCuil( value )
      });

      const store = useStore()
      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })
      const myCircle = ref({})

      const v310Modal = ref(true)
      const currentStep = ref(0);
      const lastStep = 3

      const upWizardDrugs = ref(false)
      const showAffilData = ref(false)
      const validCuil = ref(false)
      const onBlurCuit = ref(false)
      const dataAffil = ref({})
      const searchAffil = ref(false)
      const newCuilValue = ref('')
      const showV310 = ref(false)

      const prescribedDrugs = ref([])
      const dataVoucher = ref({
         //prescribedDrugs: prescribedDrugs.value
      })
      const pdfData = ref({})
      // new
      const initialTabIndex = ref(100)
      const currentTab = ref(0)
      const usersApp = ref([])
      const states = ref([])
      const readyToFilter = ref(false)
      const filterOn = ref(false)
      const radioSelectName = ref('')

      const v310Schema = [
         {
            id( value ) {
               //console.log(value)
               if ( value === undefined ) { return true }
               if ( value == '' ) { return true }

               let numberValue = Number( value )
               if ( isNaN( numberValue ) ) { return 'Debe ser un numero!' }
               if ( numberValue < 1 ) { return 'Debe ser mayor o igual a uno (1)!' }
               if ( parseInt( value ) < numberValue ) { return 'Debe ser entero' }

               return true
            }
         },
         {
            cuil: 'dfrValCuil'
         },
         yup.object({
            dateFrom: yup.date()
               .nullable()
               .transform((curr, orig) => orig === '' ? null : curr),
            dateTo: yup.date()
               .nullable()
               .transform((curr, orig) => orig === '' ? null : curr)
         }),
      ]
      /*
            prescriptionDate: yup.date().required('Fecha Requerida!'),
      */
      const lastTabIndex = [7, 3, 6, 3]

      const currentSchema = computed(() => {
         //console.log(currentStep.value)
         return v310Schema[currentStep.value];
      })

      const currentLastTabIndex = computed(() => {
         return lastTabIndex[currentStep.value];
      })

      const cmpRequestDate = computed(() => {
         return dataVoucher.value.requestDate
      })

      const v310Cnf = {
         id: {
            name: 'id',
            label: 'ID',
            type: 'text'
         },
         cuil: {
            name: 'cuil',
            label: 'C.U.I.L.',
            type: 'text'
         },
         requestDate: {
            name: 'dateField',
            label: 'Fecha de Solicitud',
            type: 'radio'
         },
         createDate: {
            name: 'dateField',
            label: 'Fecha de Autorización',
            type: 'radio'
         },
         dateFrom: {
            name: 'dateFrom',
            label: 'Desde',
            type: 'date'
         },
         dateTo: {
            name: 'dateTo',
            label: 'Hasta',
            type: 'date'
         },
         tramitNumber: {
            name: 'tramitNumber',
            label: 'Nro de Trámite',
            type: 'text'
         },
         phone: {
            name: 'phone',
            label: 'Teléfono',
            type: 'text'
         },
         specialty: {
            name: 'specialty',
            label: 'Especialidad'
         },
         disease: {
            name: 'disease',
            label: 'Enfermedad'
         },
         doctorsObservations: {
            name: 'doctorsObservations',
            label: 'Observaciones Médico'
         },
         prescriptionDate: {
            name: 'prescriptionDate',
            label: 'Fecha Prescripción',
            type: 'date'
         },
         id2: {
            name: 'id2',
            label: 'ID2',
            type: 'text'
         },
         id3: {
            name: 'id3',
            label: 'ID3',
            type: 'text'
         },
         voucherObservations: {
            name: 'voucherObservations',
            label: 'Observaciones Voucher'
         },
         internalObservations: {
            name: 'internalObservations',
            label: 'Observaciones Internas'
         }
      }

      const specialtys = ref([])
      const chronicDiseases = ref([])
      const code310Drugs = ref( {})

      const filterId = ref(false)
      const filterCuil = ref(false)
      const filterDates = ref(false)
      const filterState = ref(false)
      const filterUser = ref(false)
      const changeValue = ref(false)

      watch( dataVoucher.value, () => {
         filterId.value = false
         filterCuil.value = false
         filterDates.value = false
         filterState.value = false
         filterUser.value = false

         if ( dataVoucher.value.id !== undefined ) filterId.value = true
         if ( dataVoucher.value.cuil !== undefined ) filterCuil.value = true
         if ( dataVoucher.value.dates !== undefined ) filterDates.value = true
         if ( dataVoucher.value.stateId !== undefined ) filterState.value = true
         if ( dataVoucher.value.userId !== undefined ) filterUser.value = true
      }

      )

      function addDrugs(val) {
         prescribedDrugs.value.push(val)
         chronicDiseases.value[val.disease.value].disabled = true
      }

      function beforeClose() {
         if ( JSON.stringify( dataVoucher.value ) === '{}' ) {
            emit('cancel')
         } else {
            let text = "Si sale se perderan los datos ingresados.";
            if (confirm(text) == true) {
               emit('cancel')
            }
         }
      }

      function beforeOpen() {

         document.getElementById('ffield').focus()

         V310Service.findChronicDisease()
         .then(response => {
            chronicDiseases.value = [
               { value: '', name: 'Seleccione una Enfermedad', disabled: true }, ...response.data]
         })
         .catch(error => {
            console.log(error);
         })

         V310Service.findMedicalSpecialties()
         .then(response => {
            specialtys.value = [
               { value: '', name: 'Seleccione una Especialidad', disabled: true },
                ...response.data,
               { value: 98, name: 'Especialidad no Informada', disabled: false },
               { value: 99, name: 'Especialidad no Encontrada', disabled: false }
               ]
         })
         .catch(error => {
            console.log(error);
         })
      }

      function deletePrescribed(index) {
         let chronicIndex = prescribedDrugs.value[index].disease.value
         //console.log(chronicIndex)
         //console.log(chronicDiseases.value[chronicIndex].name)
         chronicDiseases.value[chronicIndex].disabled = false

         for (let key in prescribedDrugs.value[index].drugs) {
            //console.log(prescribedDrugs.value[index].drugs[key].name)
            let drugIndex = prescribedDrugs.value[index].drugs[key].code
            //code310Drugs.value['_'+drugIndex].free = true
            delete code310Drugs.value[drugIndex]
         }
         // code310Drugs[val.index].free = val.free
         prescribedDrugs.value.splice( index, 1)

      }

      function doFilter( value ) {
         if ( value ) {
         let data = {
            dataFilter: dataVoucher,
            dataShow: {
               filterId: filterId.value,
               filterCuil: filterCuil.value,
               filterDates: filterDates.value,
               filterState: filterState.value,
               filterUser: filterUser.value
            }
         }
         if ( filterCuil.value ) { 
            data.dataShow.cuilName = dataAffil.value.name
         }
         if ( filterDates.value ) { 
            data.dataShow.dateType = radioSelectName.value
         }
         if ( filterState.value ) { 
            data.dataShow.stateName = states.value.find(item => item.id == dataVoucher.value.stateId).name
         }
         if ( filterUser.value ) { 
            data.dataShow.userName = usersApp.value.find(item => item.id == dataVoucher.value.userId).name
         }
         emit( 'doFilter', data)
         //console.log(data)
         nextTick(() => {
            emit('cancel')
         })
         } else {
            emit( 'doFilter', {})
            filterOn.value = false
         }
      }

      function getFilterUser( id ) {
         if ( dataVoucher.value.userId == id) {
            delete dataVoucher.value.userId
         } else {
            dataVoucher.value.userId = id
         }
      }

      function getState( id ) {
         if ( dataVoucher.value.stateId == id) {
            delete dataVoucher.value.stateId
         } else {
            dataVoucher.value.stateId = id
         }
      }

      function keepValues( values ) {
         for (let key in values) {
            dataVoucher.value[key] = values[key]
            if (values[key] == "") {
               delete dataVoucher.value[key]
            }
         }
         //if ( JSON.stringify( dataVoucher.value ) === '{}' ) {
         //   readyToFilter.value = false
         //}
         //console.log(dataVoucher.value["dates"])
         if ( dataVoucher.value["dates"] === undefined ) {
               delete dataVoucher.value["dateFrom"]
               delete dataVoucher.value["dateTo"]
         }
         if ( dataVoucher.value["dateFrom"] === undefined && dataVoucher.value["dateTo"] === undefined ) {
               delete dataVoucher.value["dates"]
         }
      }

      function nextStep(values) {
         keepValues( values )
         setTimeout(() => {
            //
         if ( dataVoucher.value["dates"] !== undefined ) {
            if ( dataVoucher.value.dateFrom > dataVoucher.value.dateTo ) {
               if ( currentTab.value != 2 || readyToFilter.value ) {
                  alert('Fecha desde es mayor a fecha hasta!')
                  document.getElementById('nav-2-tab').click()
                  currentTab.value = 2
                  readyToFilter.value = false
               }
            }
         }
            //
            currentStep.value = currentTab.value
            if ( currentTab.value < 2 ) {
               nextTick(() => {
                  if ( !readyToFilter.value ) {
                     document.getElementById('ffield').focus()
                  }
               })
            }
         }, 50)
         /*
         if (currentStep.value == lastStep) {
            console.log('Done: ', JSON.stringify(dataVoucher.value, null, 2))
            return;
         } else {
            currentStep.value++;
            if ( currentStep.value == 3 ) {

               let arrDrugs = []
               for ( let key in code310Drugs.value ) {
                  arrDrugs.push( code310Drugs.value[ key ].name)
               }

               pdfData.value = {
                  //affil: { 
                     name: dataAffil.value.name, 
                     cuil: dataAffil.value.id,
                     provinceState: dataAffil.value.provinceState,
                     sex: dataAffil.value.sex,
                  //},
                  //voucher: { 
                     id: '00000000',
                     requestDate: moment(dataVoucher.value.requestDate).format('DD/MM/YYYY'),
                     prescriptionDate: moment(dataVoucher.value.prescriptionDate).format('DD/MM/YYYY'),
                     validDate: moment(dataVoucher.value.prescriptionDate).add(6, 'months').format('DD/MM/YYYY'),
                     requestCanceled: '',
                     voucherObservations: dataVoucher.value.voucherObservations,
                     userName: myCircle.value.name,
                     nowDate: moment(new Date()).format('DD/MM/YYYY'),
                     nowDateTime: moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
                  //},
                  drugs: arrDrugs
               }
               console.log(pdfData.value)
            }
            nextTick(() => {
               document.getElementById('first').focus()
            })
         }
         */
      }

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })

         let uAppIndex = store.state.auth.userAppIndex
         let uAppModule = store.state.auth.userAppModule
         let userAppModuleId = uAppModule.appModuleComponent[uAppIndex].id
         //
         AdminService.getAppMembers( userAppModuleId )
         .then(response => {
            usersApp.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
         //
         AnalyService.getStates( 0 )
         .then(response => {
            states.value = response.data
         })
         .catch(error => {
            console.log(error);
         });

         filterOn.value = props.filterOnOff
         //document.getElementById('first').focus()
         document.getElementById('ffield').focus()
      }

      function prevStep( values ) {
         if (currentStep.value <= 0) {
            return;
         }

         keepValues( values )
         currentStep.value--;
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      function radioSelect( value ) {
         radioSelectName.value = value
      }

      function tabNumber ( value ) {
         //currentStep.value = value
         console.log(value)
         if ( value < 0 ) {
            if ( readyToFilter.value ) {
               readyToFilter.value = false
            } else {
               setTimeout(() => { 
                  if ( JSON.stringify( dataVoucher.value ) !== '{}' ) {
                     readyToFilter.value = true 
                  }
               }, 50)
            }
            //readyToFilter.value = !readyToFilter.value
         } else {
            currentTab.value = value
         }
         /*
         if ( value == 2 ) {
            nextTick(() => {
               document.getElementById('nav-id-tab').click()
               document.getElementById('nav-id-tab').focus()
            })
         }
         */
      }

      function up310Drugs(drug) {
         console.log(drug)
         if (drug.option) {
            code310Drugs.value[drug.index] = {
               dose: drug.dose,
               name: drug.name
            }
         } else {
            delete code310Drugs.value[drug.index]
         }
      }

      function upCuil( cuil ) {
         console.log( cuil )
         //dataVoucher.value.cuil = cuil
         //console.log( dataVoucher.value.cuil )
         newCuilValue.value = cuil
         searchAffil.value = false
         onBlurCuit.value = false
         dataAffil.value = {}
         changeValue.value = true
         nextTick(() => {
            //document.getElementById('resetCuil').click()
            document.getElementById('first').focus()
         changeValue.value = false
         })
      }

      function updateVoucher() {
            
         let arrDiseases = []
         for ( let key in prescribedDrugs.value ) {
            
            let arrDrugs0 = []
            for ( let key2 in prescribedDrugs.value[ key ].drugs ) {
               arrDrugs0.push({
                  id: prescribedDrugs.value[ key ].drugs[key2].id,
                  code: prescribedDrugs.value[ key ].drugs[key2].code,
                  dose: prescribedDrugs.value[ key ].drugs[key2].dose
               })
            }

            arrDiseases.push({ 
               id: prescribedDrugs.value[ key ].disease.diseaseId,
               drugs: arrDrugs0
               })
         }

         dataVoucher.value.diseases = arrDiseases
         dataVoucher.value.userId = currentUserId.value
         //dataVoucher.value.createDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
         V310Service.updateVoucher(dataVoucher.value)
         .then(response => {
            let voucher310Id = response.data
            console.log(voucher310Id)
            V310Service.getVoucherPdf(voucher310Id)
            .then(response => {
               console.log(response.data)
               pdfData.value = response.data
               console.log(response.data)
               nextTick(() => {
                  showV310.value = true
               })
            })
            .catch(error => {
               console.log(error);
            })

            //emiter('v310ToDo', 'findVouchers')
            //emit('closeAdd') 
         })
         .catch(error => {
            console.log(error);
         })
      }

      function upV310(v310) {
         console.log(v310)
      }

      async function dfrValCuil( value ) {

         console.log(value)

         let promise = new Promise(( resolve ) => {
            AnalyService.affiliateExists( value )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return 'Error de red!'
               });
         })

         let result = await promise
         if ( result == 'N') {
            return 'No hay ningún Afiliado con este CUIL'
         }
         /*
         if ( result == 'I') {
            return 'No es un Afiliado Activo'
         }
         */
         if ( !findAffilData( value ) ) {
            return 'Error de red!'
         }
         return true
      }

      async function findAffilData( value ) {

         let promise = new Promise(( resolve ) => {
            AnalyService.getAffiliateBasicData( value )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return false
               });
         })

         dataAffil.value = await promise
         validCuil.value = true

         return true
      }
      
      async function generatePDF() {
         //
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         //let file = new File([blob], 'pepitito.pdf',  { type: 'application/pdf' })
         let file = new File([blob], String( 'voucher310' ) + '.pdf',  { type: 'application/pdf' })
         //
         // Create a download link for the resulting PDF Blob and trigger the download
         const downloadLink = document.createElement('a');
         downloadLink.href = URL.createObjectURL(file);
         downloadLink.download = file.name;
         downloadLink.onclick = () => downloadLink.remove();
         document.body.appendChild(downloadLink);
         downloadLink.click();
         //
         //         
      }
      function createPDF() {
         return new Promise( (resolve, reject) => {
            console.log('create PDF function executed!');
            let element = document.getElementById('element-to-print');

            let opt = {
               margin: 10,
               enableLinks: false,
               image: {type: 'jpeg', quality: 0.95},
               html2canvas: {scale: 2, useCORS: true}
               //jsPDF: {format: 'a4', orientation: 'portrait'}
            };

            try {
                const blob = html2pdf().set(opt).from(element).outputPdf('blob');
                resolve(blob);
            } catch (e) {
                reject(e);
            }
         });
      }

      return {
         addDrugs,
         beforeClose, beforeOpen,
         changeValue, cmpRequestDate, chronicDiseases, code310Drugs,
         currentLastTabIndex, currentSchema, currentStep, currentTab,
         dataAffil, dataVoucher, deletePrescribed, doFilter,
         filterOn, findAffilData,
         filterId, filterCuil, filterDates, filterState, filterUser,
         generatePDF, getFilterUser, getState,
         lastStep,
         myCircle,
         nextStep, newCuilValue,
         onBlurCuit, opened,
         pdfData, prescribedDrugs,prevStep,
         radioSelect, radioSelectName, readyToFilter,
         searchAffil, showAffilData, showV310, specialtys, states,
         tabIndexNumber, tabNumber,
         v310Cnf, v310Modal, v310Schema, validCuil,
         up310Drugs, upCuil, updateVoucher, upV310, upWizardDrugs, usersApp
      }
   },
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /*align-items: center;*/
}
::v-deep(.v310-modal-content) {
  /*
  min-width: 350px;
  max-width: 750px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  width: 350px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
/*
  margin: 0 1rem;
*/
.up-voucher {
   background-color: #9E9E9E ;
   /*
   background-color: blue ;
   background-color: #9E9E9E ;
   margin-top: 10px ;
   max-width: 500px;
   max-width: 500px;
   */
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
.tx-cl-red {
   color: red;
}
.fs-14 {
   font-size: 14px;
}
.bg-contrast {
   background-color: #d2cece;
}
.border-contrast {
   border: 1px solid #d2cece;
}
.tr-drugs {
   font-size: 0.875rem;
}
td {
   height: 1.5rem;   
}
.pill {
   height: 1.5rem;   
}
.list-filter:hover {
   background-color: #787878;

}
.nav-link {
   color: white;
}
/*
.btn-info {
   opacity: .8;
}
.btn-info:hover {
   opacity: 1;
}
*/
</style>
